<template>
	<v-container>
		<v-speed-dial v-model="fab" :fab="false" :direction="direction" :transition="transition" fling right bottom fixed large>
			<v-btn slot="activator" v-model="fab" fab>
				<v-avatar :tile="false">
					<img v-if="user.picture" :src="user.picture" alt="avatar" />
					<v-icon v-else>person</v-icon>
					<v-icon>account_circle</v-icon>
				</v-avatar>
			</v-btn>
			<v-tooltip top>
				<v-btn slot="activator" fab dark small color="red darken3" @click="showDialog = true">
					<v-icon>power_settings_new</v-icon>
				</v-btn>
				<span>Logout</span>
			</v-tooltip>
		</v-speed-dial>
		<v-dialog v-model="showDialog" max-width="320">
			<v-card>
				<v-card-title class="headline">Do you really want to logout?</v-card-title>
				<v-card-text>
					You can only use this application when you are logged into your @trakken account
				</v-card-text>

				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="darken-1" flat="flat" @click="showDialog = false">
						cancel
					</v-btn>
					<v-btn color="red darken-3" class="white--text" @click="signOut">
						Logout
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-container>
</template>
<script>
export default {
	name: 'UserBadge',
	props: {},
	data() {
		return {
			showDialog: false,
			fab: false,
			direction: 'left',
			transition: 'scale-transition'
		}
	},
	computed: {
		user() {
			return this.$store.state.user
		}
	},
	methods: {
		signOut() {
			this.$store.dispatch('logout')
		}
	}
}
</script>
